export enum CONVERSATION_TYPE {
  PRIVATE = 1,
  GROUP = 2
}
